Ext.define('SA.view.newproject.VariablesList', {
    alias: 'widget.new-project-variables-list',
    extend: 'Ext.Component',

    cls: 'sa-new-project-variables-list',

    tpl: [
        '<tpl for=".">',
            '<label class="sa-new-project-variables-list-item">',
                '<input type="checkbox" value="{attribute:htmlEncode}" <tpl if="selected">checked</tpl>>',
                '{name:htmlEncode}',
            '</label>',
        '</tpl>'
    ],

    getSelectedAttributes() {
        var checked = this.el.query('input[type=checkbox]:checked');

        return checked.map(el => el.value);
    }
});